module.exports = __webpack_public_path__ + "static/media/NotoSans-Bold.9bce1a24.woff2";